import React, { useState, useEffect } from "react";
import * as sweetalert from "sweetalert";
import axios from "axios";
import { getAllBanks, getAllPaymentMethods } from "../../../services";
import Controls from "../global/controls/Controls";
import { useForm, Form } from "../Notifcations/useForm";
import { Grid } from "@material-ui/core";
import { getEPaymentConfig } from "../../../services/EPaymentConfig";
import packageJson from "../../../../package.json";
import ConfirmDialog from "../global/ConfirmDialogCon";
import { getAllServices } from "../../../services/Services";

export const BaseUrl = packageJson.projectURlApi.BaseUrl;
export default function AddEPayment() {
  const [Paymentconfigration, setGetPaymentconfigration] = useState([]);
  const [paymentMethod, setPaymentMethod] = useState([]);
  const [discount_fatora_bank, setDiscount_fatora_bank] = useState([]);
  const [increase_sell_percent, setIncrease_sell_percent] = useState([]);
  const [Profit, setProfit] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [Banks, setBanks] = useState([]);
  const [ServicesData, setServices] = useState([]);

  const [confirmDialog2, setConfirmDialog2] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const [loadingFatora, setLoadingFatora] = useState(false);
  const staff_type = localStorage.getItem("staff_type");
  const mobile_number_login = localStorage.getItem("mobile_number_login");
  useEffect(() => {
    setIsLoading(true);
    getEPaymentConfig()
      .then((res) => {
        setGetPaymentconfigration(res);

        setIsLoading(true);
      })
      .catch((err) => {
        setGetPaymentconfigration([]);
        setIsLoading(false);
      });
    getAllBanks().then((res) => {
      setBanks(res);
    });
    getAllPaymentMethods()
      .then((res) => {
        setPaymentMethod(res.data);
        setIsLoading(true);
      })
      .catch((err) => {
        setGetPaymentconfigration([]);
        setIsLoading(false);
      });
      getAllServices()
      .then((res) => {
        setServices(res);
        setIsLoading(false);
      })
      .catch((err) => {
        setServices([]);
        setIsLoading(false);
      });
    return () => {};
  }, []);
  useEffect(() => {
    if(loadingFatora === true && !validate()) {
    setTimeout(() => {
      // After the timeout, reset the loading state
      setLoadingFatora(false);
      // Your other logic here
    }, 2000); // Adjust the timeout duration as needed
    }
  }, [loadingFatora]);
  useEffect(() => {}, [discount_fatora_bank, increase_sell_percent]);
  const initialFValues = {
    mobile: "",
    national_id: "",
    name: "",
    paymentId: "",
    amount: "",
  };
  const validate = (fieldValues = loginInput) => {
    let temp = { ...errors };
    if ("mobile" in fieldValues) {
      if (fieldValues.mobile == "") {
        temp.mobile = " رقم الموبايل مطلوب";
      } else if (!/[0-9]/.test(fieldValues.mobile)) {
        temp.mobile = "يجب أن يكون رقم الموبايل أرقام";
      }
      else if (fieldValues.mobile.length !== 10) {
        temp.mobile = "يجب أن يكون رقم الموبايل 10 أرقام";

      } 
      else {
        temp.mobile = "";
      }
    }
    if ("national_id" in fieldValues) {
      if (fieldValues.national_id == "") {
        temp.national_id = " الرقم الوطني مطلوب";
      } else if (!/[0-9]/.test(fieldValues.national_id)) {
        temp.national_id = "يجب أن يكون الرقم الوطني أرقام";
      } 
      else if (fieldValues.national_id.length !== 11) {
        temp.national_id = "يجب أن يكون رقم الوطني 11 رقمًا";
      }
      else {
        temp.national_id = "";
      }
    }
    if ("name" in fieldValues)
      temp.name = fieldValues.name ? "" : "الحقل مطلوب";
    if ("amount" in fieldValues)
      temp.amount = fieldValues.amount ? "" : "الحقل مطلوب";

    setErrors({
      ...temp,
    });
    if (fieldValues == loginInput)
      return Object.values(temp).every((x) => x == "");
  };
  const validate2 = (fieldValues = loginInput) => {
    let temp = { ...errors };
    if ("mobile" in fieldValues) {
    if (fieldValues.mobile !== "" && !/^[0-9]+$/.test(fieldValues.mobile)) {
        temp.mobile = "يجب أن يكون رقم الموبايل أرقام فقط";
      } else if (fieldValues.mobile !== "" && fieldValues.mobile.length !== 10) {
        temp.mobile = "يجب أن يكون رقم الموبايل 10 أرقام";
      } 
      else {
        temp.mobile = "";
      }
    
    }
    setErrors({
      ...temp,
    });
    if (fieldValues == loginInput)
      return Object.values(temp).every((x) => x == "");
  };
  const {
    loginInput,
    setLogin,
    errors,
    setErrors,
    handleInputChange,
    addForm,
  } = useForm(initialFValues, true, validate,validate2);

  const handleSubmit = () => {
 
    if (validate()) {
      setLoadingFatora(true);
      const bodyFormData = new FormData();
      bodyFormData.append("amount", loginInput.amount);
      bodyFormData.append("mobile", loginInput.mobile);
      bodyFormData.append("national_id", loginInput.national_id);
      bodyFormData.append("name", loginInput.name);
      axios
        .post(`${BaseUrl}/api/addPaymentFatora`, bodyFormData, {
          withCredentials: true,
        })
        .then((res) => {
          if (res.data.status === true) {
            setLoadingFatora(false);
            const url = res.data.data.url;
            sweetalert("سيتم توجيهك الى نافذة الدفع الالكتروني", {
              className: "alert-div",
              button: {
                text: "تم",
              },
            }).then((res) => {
              window.open(url, "_blank");
              window.location.reload();
            });
          } else {
            setLoadingFatora(false);
            sweetalert(res.data.msg, {
              className: "alert-div",
              button: {
                text: "تم",
              },
            });
          }
    });
    }else{

    }
  };
  const handleChange = (e, fieldName) => {
    const value = parseFloat(e.target.value);
    const data={
      amount:value,
    }
    if (!isNaN(value)) {
      if (fieldName === "amount") {
        axios
        .post(`${BaseUrl}/api/fatoraAmountDetails`,data, {
          withCredentials: true,
        })
        .then(response => {
   
        setDiscount_fatora_bank(response.data.data.amount_send_to_bank);
        setProfit(response.data.data.profit_amount);
        setIncrease_sell_percent(response.data.data.sell_amount);
        setLogin({ ...loginInput, amount: value });
        })
      }
    } else {
      console.error("Invalid number entered");
    }
  };

  useEffect(() => {
    validate2(loginInput);
  }, [loginInput]);
  return (
    <div className="main-div">
      <h3 className="titlepage">دفع الكتروني جديد</h3>
      {ServicesData[4]?.name == "E_Payment" &&
      ServicesData[4]?.is_active == 1 ? (
      <Grid className="form-group new-design" >
        <Grid container maxWidth="sm" spacing={4}>
          <Grid item md={6} xs={12}>
            <Controls.Input
              label="الاسم"
              name="name"
              variant="outlined"
              fullWidth
              onChange={handleInputChange}
              value={loginInput.name}
              className="form-control"
              error={errors.name}
              type="text"
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <Controls.Input
              label="رقم الموبايل"
              name="mobile"
              variant="outlined"
              fullWidth
              onChange={handleInputChange}
              value={loginInput.mobile}
              className="form-control"
              error={errors.mobile}
              type="number"
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <Controls.Input
              label="الرقم الوطني"
              name="national_id"
              variant="outlined"
              fullWidth
              onChange={handleInputChange}
              value={loginInput.national_id}
              className="form-control"
              error={errors.national_id}
              type="number"
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <Controls.Input
              label="القيمة"
              name="amount"
              variant="outlined"
              fullWidth
              onChange={(e) => handleChange(e, "amount")}
              className="form-control"
              type="number"
              error={errors.amount}
            />
          </Grid>
          <Grid item md={4} xs={12}>
            <Controls.Input
              label="القيمة التي يتم إرسالها للبنك"
              name=""
              variant="outlined"
              disabled
              fullWidth
              value={discount_fatora_bank}
              className="form-control"
            />
          </Grid>
          <Grid item md={4} xs={12}>
            <Controls.Input
              label="سعر المبيع"
              name=""
              variant="outlined"
              fullWidth
              disabled
              value={increase_sell_percent || ""}
              className="form-control"
            />
          </Grid>
          <Grid item md={4} xs={12}>
            <Controls.Input
              label="العمولة"
              name=""
              variant="outlined"
              fullWidth
              disabled
              value={Profit || ""}
              className="form-control"
            />
          </Grid>
        </Grid>

        {/* <Grid item md={6} xs={12} spacing={2} class="div-btn-submit"> */}
        <Grid item md={6} xs={12} spacing={2} class="div-btn-submit">
          {loadingFatora === true ? (
            <Controls.Button
              type="submit"
              text=<div class="spinner center">
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
              </div>
              variant="contained"
              className="btn-submit"
            ></Controls.Button>
          ) : (
          <>
            <Controls.Button
              type="submit"
              text={"دفع"}
              onClick={() => {
                if(validate()){
                    setConfirmDialog2({
                      isOpen: true,
                      title: "هل تريد القيام بهذه العملية",
                      subTitle: "",
                      onConfirm: () => {
                        handleSubmit();
                      },
                    });
                    }
                  }}
              variant="contained"
              className="btn-submit"
            ></Controls.Button>
                    <ConfirmDialog
                confirmDialog={confirmDialog2}
                setConfirmDialog={setConfirmDialog2}
              />
          </>
          )}
        </Grid>
      </Grid>
      ) : ServicesData[4]?.name == "E_Payment" &&
        ServicesData[4]?.is_active == 0 && staff_type == "Admin" &&
                  mobile_number_login == "0950555563"? (
                    <Grid className="form-group new-design" >
        <Grid container maxWidth="sm" spacing={4}>
          <Grid item md={6} xs={12}>
            <Controls.Input
              label="الاسم"
              name="name"
              variant="outlined"
              fullWidth
              onChange={handleInputChange}
              value={loginInput.name}
              className="form-control"
              error={errors.name}
              type="text"
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <Controls.Input
              label="رقم الموبايل"
              name="mobile"
              variant="outlined"
              fullWidth
              onChange={handleInputChange}
              value={loginInput.mobile}
              className="form-control"
              error={errors.mobile}
              type="number"
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <Controls.Input
              label="الرقم الوطني"
              name="national_id"
              variant="outlined"
              fullWidth
              onChange={handleInputChange}
              value={loginInput.national_id}
              className="form-control"
              error={errors.national_id}
              type="number"
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <Controls.Input
              label="القيمة"
              name="amount"
              variant="outlined"
              fullWidth
              onChange={(e) => handleChange(e, "amount")}
              className="form-control"
              type="number"
              error={errors.amount}
            />
          </Grid>
          <Grid item md={4} xs={12}>
            <Controls.Input
              label="القيمة التي يتم إرسالها للبنك"
              name=""
              variant="outlined"
              disabled
              fullWidth
              value={discount_fatora_bank}
              className="form-control"
            />
          </Grid>
          <Grid item md={4} xs={12}>
            <Controls.Input
              label="سعر المبيع"
              name=""
              variant="outlined"
              fullWidth
              disabled
              value={increase_sell_percent || ""}
              className="form-control"
            />
          </Grid>
          <Grid item md={4} xs={12}>
            <Controls.Input
              label="العمولة"
              name=""
              variant="outlined"
              fullWidth
              disabled
              value={Profit || ""}
              className="form-control"
            />
          </Grid>
        </Grid>

        {/* <Grid item md={6} xs={12} spacing={2} class="div-btn-submit"> */}
        <Grid item md={6} xs={12} spacing={2} class="div-btn-submit">
          {loadingFatora === true ? (
            <Controls.Button
              type="submit"
              text=<div class="spinner center">
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
              </div>
              variant="contained"
              className="btn-submit"
            ></Controls.Button>
          ) : (
          <>
            <Controls.Button
              type="submit"
              text={"دفع"}
              onClick={() => {
                if(validate()){
                    setConfirmDialog2({
                      isOpen: true,
                      title: "هل تريد القيام بهذه العملية",
                      subTitle: "",
                      onConfirm: () => {
                        handleSubmit();
                      },
                    });
                    }
                  }}
              variant="contained"
              className="btn-submit"
            ></Controls.Button>
                    <ConfirmDialog
                confirmDialog={confirmDialog2}
                setConfirmDialog={setConfirmDialog2}
              />
          </>
          )}
        </Grid>
      </Grid>
      ) 
      : ServicesData[4]?.name == "E_Payment" &&
        ServicesData[4]?.is_active == 0 ? (
        <div class="services-no-available">
          هذه الخدمة غير متاحة
          <img src="7703205.webp" />
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}
